import { createSelector } from 'reselect';
import { getAllResources } from '../../../redux/store/store-helper';

export const getDeployedResources = createSelector(getAllResources, (allResources) => (allResources || []).filter(({ isDeployed }) => isDeployed));